import { createCtx } from '@mi-front/core';
import React, { ReactNode } from 'react';
import Async, { AsyncFulfilled } from 'react-async';
import { LoaderData, ViewError, ViewLoader } from './components';

export type AsyncChildProps<Data> = AsyncFulfilled<Data>;

export interface AsyncViewProps<Data, Query = object> {
  promiseFn: (args: { query: Query }) => Promise<Data>;
  children: (p: AsyncChildProps<Data>) => React.ReactElement;
  query?: Query;
  loader?: LoaderData;
  silent?: boolean;
  customLoader?: ReactNode;
}

export const [useAsyncViewCtx, AsyncViewCtxProvider] = createCtx<{
  reload: () => any;
}>();

/**
 * TODO: replace with react-query
 */
export function AsyncView<Data, Query = object>(viewProps: AsyncViewProps<Data, Query>) {
  const { children, customLoader, loader, promiseFn, query, silent } = viewProps;

  return (
    <Async promiseFn={promiseFn as any} query={query}>
      {(p) => {
        if (p.isPending && (!silent || p.counter <= 1)) {
          return customLoader || <ViewLoader loaderData={loader} />;
        }

        if (p.error) {
          return <ViewError error={p.error} />;
        }

        if (typeof p.data !== 'undefined') {
          return (
            <AsyncViewCtxProvider value={{ reload: p.reload }}>
              {children({
                ...p,
                query: query || {},
              } as any)}
            </AsyncViewCtxProvider>
          );
        }

        return null;
      }}
    </Async>
  );
}
